var _defs, _path, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg500InternalServerErrorIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-3, .cls-4, .cls-5 {\n        stroke: gray;\n      }\n\n      .cls-7 {\n        fill: #8cc63f;\n      }\n\n      .cls-8 {\n        fill: #fff;\n      }\n\n      .cls-9 {\n        fill: #e4f2fa;\n      }\n\n      .cls-10 {\n        fill: #a5845f;\n      }\n\n      .cls-11 {\n        fill: #bbbdbf;\n      }\n\n      .cls-2 {\n        stroke: #000;\n      }\n\n      .cls-2, .cls-6 {\n        stroke-width: 2px;\n      }\n\n      .cls-12 {\n        fill: #bc966e;\n      }\n\n      .cls-13 {\n        fill: #333;\n      }\n\n      .cls-3 {\n        stroke-dasharray: 4.24 10.6;\n      }\n\n      .cls-4 {\n        stroke-dasharray: 3.62 9.04;\n      }\n\n      .cls-14 {\n        fill: #c39b71;\n      }\n\n      .cls-15 {\n        fill: #ffc841;\n      }\n\n      .cls-16 {\n        fill: #e95c2b;\n      }\n\n      .cls-17 {\n        fill: #b3b3b3;\n      }\n\n      .cls-18 {\n        fill: #f16522;\n      }\n\n      .cls-19 {\n        fill: gray;\n      }\n\n      .cls-5 {\n        stroke-dasharray: 3.2 8.01;\n      }\n\n      .cls-20 {\n        fill: #fdc24e;\n      }\n\n      .cls-21 {\n        fill: #bd9671;\n      }\n\n      .cls-22 {\n        fill: #4e3a22;\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-6 {\n        stroke: #bbbdbf;\n        stroke-dasharray: 4 10;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-24 {\n        fill: #e6e6e6;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M241.5,192.53c-.6.53-1.05,1-1.43,1.5-1.96,2.52-2.84,4.86-3.15,5.76-2.56,7.34-8.73,13.95-9.91,15.19,0,0-1.32,1.39-2.72,2.6-8.43,7.32-17.13,3.83-24.94,8.87-3.63,2.34-8.83,7.56-8.18,11.34,2.93,17.01,126.39,16.74,128.46,2.09.19-1.35-.95-2.63-3.29-5.14-9.88-10.61-29.59-7.29-39.27-20.38-2.35-3.18-3.39-6.35-3.86-8.13.02-1.15,0-10.34-7.04-15.65-9.41-7.1-22.1-.3-24.65,1.96Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M94.94,724.35h543.99c6.12,0,10.8-5.44,9.89-11.49l-74.95-497.29c-.74-4.89-4.94-8.51-9.89-8.51H233.07c-4.49,0-8.43,3-9.64,7.32l-138.13,497.29c-1.77,6.37,3.02,12.68,9.64,12.68Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395.47,
    y: 479.07,
    width: 302.7,
    height: 230.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 380.11,
    y: 468.7,
    width: 336.5,
    height: 70.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 478.69,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 492.52,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 506.35,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 520.17,
    width: 99.87,
    height: 9.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 482.91,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 682.03,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 496.74,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 589.84,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 510.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 524.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 524.4,
    r: 3.84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 380.11,
    y: 559.36,
    width: 336.5,
    height: 70.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 569.34,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 583.17,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 597,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 610.83,
    width: 99.87,
    height: 9.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 543.75,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 559.11,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 666.67,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 697.4,
    cy: 573.57,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 587.4,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 601.23,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 589.84,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 615.06,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 615.06,
    r: 3.84
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 380.11,
    y: 650.01,
    width: 336.5,
    height: 70.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 660,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 673.83,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 687.66,
    width: 99.87,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 392.4,
    y: 701.49,
    width: 99.87,
    height: 9.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 664.22,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 559.11,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 574.48,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 589.84,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 678.05,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 651.3,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 682.03,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 691.88,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 543.75,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 559.11,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 574.48,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 589.84,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 605.21,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 620.57,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 635.94,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 651.3,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 666.67,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 682.03,
    cy: 705.71,
    r: 3.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 697.4,
    cy: 705.71,
    r: 3.84
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.36,
    y1: 323.44,
    x2: 548.36,
    y2: 151.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M626.39,125.99h.02c0,14.2-11.51,25.72-25.72,25.72h-109.83c-11.35,0-20.56-9.2-20.56-20.56v-5.06c0-9.09,7.24-16.6,16.33-16.76.64-.01,1.26,0,1.88.07,3.5-9.35,12.51-16.01,23.08-16.01,4.88,0,9.44,1.42,13.26,3.87,5.02-12.66,17.38-21.62,31.83-21.62,16.95,0,31.02,12.32,33.75,28.49,3.5-1.99,7.56-3.14,11.89-3.14,13.3,0,24.09,10.78,24.09,24.09,0,.3,0,.6-.02.9Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 462.47,
    y: 333.44,
    width: 171.77,
    height: 122.21,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M465.26,353.94h166.18v95.11c0,2.21-1.79,4-4,4h-158.18c-2.21,0-4-1.79-4-4v-95.11h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 465.26,
    y: 336.42,
    width: 166.18,
    height: 17.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 475.71,
    cy: 345.37,
    r: 3.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 485.02,
    cy: 345.37,
    r: 3.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 494.34,
    cy: 345.37,
    r: 3.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M456.57,452.68h183.57c1.47,0,2.67,1.2,2.67,2.67v7.35c0,3.31-2.69,6-6,6h-176.91c-3.31,0-6-2.69-6-6v-7.35c0-1.47,1.2-2.67,2.67-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M511.64,452.96h73.43c.59,0,1.07.48,1.07,1.07h0c0,2.95-2.39,5.34-5.34,5.34h-64.88c-2.95,0-5.34-2.39-5.34-5.34h0c0-.59.48-1.07,1.07-1.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M582.71,427.66l-33.36-54.68c-.55-.89-1.84-.89-2.39,0l-33.36,54.68c-.57.93.1,2.13,1.19,2.13h66.72c1.09,0,1.76-1.2,1.19-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M545.17,393.26c-.08-1,.5-1.8,1.46-1.8h3.01c.96,0,1.59.79,1.51,1.8l-1.46,17.07c-.08.92-.71,1.51-1.55,1.51s-1.42-.59-1.51-1.51l-1.46-17.07ZM548.14,414.88c1.72,0,2.97,1.25,2.97,2.89v.42c0,1.63-1.25,2.89-2.97,2.89s-2.97-1.25-2.97-2.89v-.42c0-1.63,1.3-2.89,2.97-2.89Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M291.35,203.07c-16.27-.08-16.9,6.56-35.21,7-19.27.46-19.89-6.86-39.16-7-2.14-.02-6.69.04-9.84-3-4.49-4.34-3.27-12.24-3-14,1.15-7.46,5.05-10.18,8-16,2.62-5.17,4.75-13.28,2-25.91h80.05c-.93,14.22,2.47,23.21,5.95,28.91,3.05,4.99,7.25,9.22,7,16-.03.82-.36,7.18-5,11-3.82,3.15-8.67,3.01-10.79,3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M241.5,192.53c-.6.53-1.05,1-1.43,1.5-1.96,2.52-2.84,4.86-3.15,5.76-2.56,7.34-8.73,13.95-9.91,15.19,0,0-1.32,1.39-2.72,2.6-8.43,7.32-17.13,3.83-24.94,8.87-3.63,2.34-8.83,7.56-8.18,11.34,2.93,17.01,126.39,16.74,128.46,2.09.19-1.35-.95-2.63-3.29-5.14-9.88-10.61-29.59-7.29-39.27-20.38-2.35-3.18-3.39-6.35-3.86-8.13.02-1.15,0-10.34-7.04-15.65-9.41-7.1-22.1-.3-24.65,1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 265.64,
    cy: 196.07,
    rx: 27,
    ry: 36.5,
    transform: "translate(-10.34 377.3) rotate(-69.73)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M256.08,101.97c-18.43-1.09-30.36,14.38-31.86,16.39-16.61,22.26-11.73,56.69,5.03,76.17,3.86,4.49,13.57,15.77,27.11,15.33,12.63-.41,21.13-10.76,24.88-15.33,16.14-19.66,19.26-52.92,3.35-75.21-2.74-3.83-12.63-16.42-28.51-17.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5,144.11c3.89-1.86,7.19.28,11.08,1.89-1.89-4.47-7.89-6.41-11.18-4.07-.58.41-1.28.83-1.02,1.72.16.53.73.66,1.12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.94,149.07c.36.25.94.22,1.18-.27.41-.83-.21-1.36-.71-1.86-2.85-2.86-9.09-1.97-11.71,2.11,4.1-.93,7.72-2.47,11.24.02Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.86,
    cy: 155.73,
    rx: 2.72,
    ry: 3.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.73,
    cy: 155.73,
    rx: 2.72,
    ry: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.14,189.07c-1.72-.93-3.08-1.05-4-1-1.52.08-2.21.67-4,1-1.66.3-3.07.16-4,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M258.58,101.76c.51.59.56,3.26.59,8.61.04,7.28.05,10.94-.59,12.05-3,5.17-11.57,6.81-17.14,8.61,0,0,0,0,0,0-15.59,4.37-19.65,18.61-24.23,16.64-3.89-1.67-4-13.23,0-22.38,9.02-20.63,38.09-27.31,41.37-23.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M261.53,101.76c-.38.59-.42,3.26-.44,8.61-.03,7.28-.04,10.94.44,12.05,2.24,5.17,8.66,6.81,12.82,8.61,0,0,0,0,0,0,11.67,4.37,14.7,18.61,18.13,16.64,2.91-1.67,2.99-13.23,0-22.38-6.75-20.63-28.5-27.31-30.95-23.53Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 293.61,
    cy: 154.24,
    rx: 3.52,
    ry: 10.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 213.89,
    cy: 154.24,
    rx: 3.52,
    ry: 10.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.14,161.07c.12,1.06.38,2.74,1,4.67,1.46,4.59,3.66,6.66,3,8.17-.23.53-.9,1.16-3,1.17"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 265.94,
    y: 653.56,
    width: 30,
    height: 51.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 136.7,
    y: 653.42,
    width: 42.48,
    height: 30,
    transform: "translate(-528.27 697.64) rotate(-79.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M307.81,172.58c-5.43-2.6-12.54-7.14-15.87-15.02-2.93-6.94-.09-9.72-2-21-2.42-14.24-8.75-20.35-5.53-24.67.58-.78,1.51-1.55,3.07-2.06,3.53-1.16,7.43.04,9.88,2.83,9.04,10.31,15.14,19.31,19.08,25.77,2.73,4.48,5.1,8.85,6.04,13.77l52.85,23.73c4.74,2.12,6.44,7.98,3.58,12.32l-32.52,49.23-25.03-16.54,18.53-28.04-32.08-20.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M145.47,285.14c-.56,1.03-.11,2.32.97,2.78l36.99,15.98c.88.38,1.9.08,2.44-.7l16.57-24.14-3,45,108-2,12.38-53.04c.08-.35.25-.66.49-.92l29.66-31.35c.67-.71.73-1.8.15-2.58l-24.06-31.95c-.81-1.07-2.42-1.06-3.21.02-6.24,8.61-12.48,17.22-18.72,25.82-8.33-3.67-16.67-7.33-25-11-1.23,1.49-10.13,11.89-25,12-16.67.12-26.15-12.8-27-14-9.78,1.27-23.89,4.73-37.03,14.73-2.52,1.92-4.77,3.9-6.79,5.88l-37.84,49.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.1,271.66c2.34-15.53,4.69-31.06,7.03-46.59-2.23-1.01-4.56-2.02-7-3-2.75-1.11-5.42-2.1-8-3-2.3,19.34-4.6,38.67-6.89,58.01-.44,3.7-3.58,6.49-7.3,6.49h-32.71c-3.7,0-6.83-2.75-7.29-6.42-2.6-20.36-5.2-40.71-7.8-61.07-2.72.23-6.16.77-10,2-3.69,1.18-6.7,2.67-9,4l11.69,60.69c.85,4.4,0,8.95-2.39,12.74l-8.27,13.16c-4.05,6.45-6.01,13.99-5.61,21.59l2.7,50.79-81.82,275.02,59,10,72.69-216.99,12.95,227.49h56.85l-8.72-350.79c-.18-7.33-2.41-14.45-6.43-20.58l-8.48-11.84c-4.49-6.27-6.36-14.05-5.21-21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,720.56h-92.5v-35c4.74,2.96,11.97,6.5,21,7,15.46.86,20.26-8.07,36.5-7,3.58.24,15.68,1.21,24.75,10.25,5.98,5.97,8.29,13.11,8.68,14.34,1.31,4.19,1.58,7.87,1.57,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,694.13l90.69,18.19,6.88-34.32c-5.23,1.97-13.01,4.02-21.97,2.73-15.33-2.2-18.28-11.9-34.41-14.04-3.56-.47-15.61-1.9-26.28,5.18-7.04,4.68-10.71,11.22-11.33,12.35-2.11,3.85-3.09,7.41-3.59,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M220.49,388.17l99.79-36.15c.64-.23,1.09-.8,1.17-1.47,1.19-9.89,7.76-18.77,17.76-22.39,7.16-2.59,14.68-1.99,21.05,1.07,1.43.69,1.32,2.77-.18,3.31l-7.37,2.67c-.6.22-1.04.74-1.16,1.38l-2.88,16.18c-.11.63.12,1.28.61,1.69l12.58,10.59c.49.41,1.17.53,1.77.31l7.37-2.67c1.49-.54,2.91.98,2.25,2.43-2.93,6.42-8.32,11.71-15.48,14.3-10.01,3.62-20.73,1.01-27.98-5.82-.49-.46-1.2-.61-1.84-.38l-99.79,36.15c-.64.23-1.09.8-1.17,1.47-1.19,9.89-7.76,18.77-17.76,22.39-7.16,2.59-14.68,1.98-21.05-1.07-1.43-.69-1.32-2.77.18-3.31l7.37-2.67c.6-.22,1.04-.74,1.16-1.38l2.88-16.18c.11-.63-.12-1.28-.61-1.69l-12.58-10.59c-.49-.41-1.17-.53-1.77-.31l-7.37,2.67c-1.49.54-2.91-.98-2.25-2.43,2.93-6.42,8.32-11.71,15.48-14.3,10.01-3.62,20.73-1.01,27.98,5.82.49.46,1.2.61,1.84.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M172.31,322.98l8.5-20.72-27.75-11.39-15.61,38.02c-1.11,2.7-.22,5.8,2.15,7.5l84.36,60.74c3.51,2.53,7.73,3.89,12.05,3.89,7.98-1.15,15.95-2.31,23.93-3.46,4.21.49,10.09.82,17,0,21.92-2.59,42.39-15.31,41-21-1.21-4.95-19.58-7.06-29-7-1.98.01-8.83.16-9-1-.04-.26.27-.53,2.33-1.84,3.77-2.38,4.69-2.71,4.67-3.16-.06-1.03-5.08-2.05-10-2-11.13.12-25.06,5.73-28.33,12.6-.06-.02-.61,2.42-.67,2.4l-75.63-53.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "228.14 304.07 228.14 338.51 253.64 353.24 279.14 338.51 279.14 304.07 228.14 304.07"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "230.14 304.07 228.14 304.07 228.14 306.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 228.14,
    y1: 314.08,
    x2: 228.14,
    y2: 332.51
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "228.14 336.51 228.14 338.51 229.87 339.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 239.05,
    y1: 344.82,
    x2: 247.31,
    y2: 349.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "251.9 352.24 253.64 353.24 255.37 352.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 264.55,
    y1: 346.94,
    x2: 272.81,
    y2: 342.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "277.4 339.51 279.14 338.51 279.14 336.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 279.14,
    y1: 328.5,
    x2: 279.14,
    y2: 310.08
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "279.14 306.07 279.14 304.07 277.14 304.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 268.1,
    y1: 304.07,
    x2: 234.65,
    y2: 304.07
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500InternalServerErrorIllustration);
export default __webpack_public_path__ + "static/media/500-internal-server-error-illustration.71686444a726a67aed55e8f6689c7f44.svg";
export { ForwardRef as ReactComponent };